export default __webpack_public_path__ + "static/media/confirmation-loader.a5cc985a.svg";